import ApplicationState from "@insite/client-framework/Store/ApplicationState";

import { IncoTermUrlSettingModel, ShowMiniCartSettingModel, VATForPDPModel, DigitalProductModel, LaunchDarklySettingsModel, customGeneralSettingsModel, PiyoviSettingsModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowShippingSettingSettingModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowForeignStockInCountryModel } from "@MasterBluePrint/Types/ApiModels";
import { ShowVendorStocksModel } from "@MasterBluePrint/Types/ApiModels";
import { Stripe3DSSettingsModel } from "@MasterBluePrint/Types/ApiModels";

export function getIncoTermUrlSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.incoTermUrl as IncoTermUrlSettingModel | undefined;
}


export function getShowShippingAndTaxSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showTaxAndShippingInCheckoutShipping as ShowShippingSettingSettingModel | undefined;
}

export function getShowMiniCartSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showMiniCart as ShowMiniCartSettingModel | undefined;
}

export function showForeignStockMessageSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showForeignStockInCountry as ShowForeignStockInCountryModel | undefined;
}

export function showVendorStocksSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.showVendorStocks as ShowVendorStocksModel | undefined;
}


export function getStripe3DSSettings(state: ApplicationState) {   
    return state.context.settings.settingsCollection.stripe3DSSettings as Stripe3DSSettingsModel | undefined;
}

export function VATForPDPSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.vatForPDP as VATForPDPModel | undefined;
}

export function piyoviSettingSelector(state: ApplicationState) {
    return state.context.settings.settingsCollection.piyoviSettings as PiyoviSettingsModel | undefined;
}


export function DigitalProductSetting(state: ApplicationState) {
    return state.context.settings.settingsCollection.digitalProduct as DigitalProductModel | undefined;
}

export function getLaunchDarklySettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.launchDarklySettings as LaunchDarklySettingsModel;
}

export function getCustomGeneralSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.customGeneralSettings as customGeneralSettingsModel;
}
